<script setup lang="ts">
import { type ID, IconRefresh } from '#shared'
import type { Message } from '../model/message'
import { useEditMessageMutation } from '../state/edit-message-mutation'
import { useSendMessageMutation } from '../state/send-message-mutation'

const { message, chatId } = defineProps<{ message: Message; chatId: ID }>()

const sendMessageMutation = useSendMessageMutation(chatId)
const editMessageMutation = useEditMessageMutation(chatId)
const onResend = () => {
  if (message.meta?.isEdited) {
    editMessageMutation.mutate({
      ...message,
      meta: { resentId: message.id, isEdited: true },
      clientId: message.clientId!,
    })
  } else {
    sendMessageMutation.mutate({ ...message, meta: { resentId: message.id }, clientId: message.clientId! })
  }
}
</script>

<template>
  <button :class="$style.resendButton" :disabled="sendMessageMutation.isPending.value" @click="onResend">
    <IconRefresh :class="$style.resendButtonIcon" />
    <span>Send again</span>
  </button>
</template>

<style lang="scss" module>
.resendButton {
  background-color: #303035;
  padding: 8px 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  width: fit-content;
  border-radius: 2px;
  transition: opacity 0.2s;
  border: none;
  cursor: pointer;

  &:disabled {
    opacity: 0.5;
  }
}

.resendButtonIcon {
  width: 15px;
  height: 15px;
}
</style>
